import {atom} from "recoil";
import {
    AncillaryCreation,
    AncillaryEntityResponse,
    AncillarySelectFE,
    FormSearchAncillaryModel
} from "../api/types/ancillary";
import {SelectElementModelFE} from "../api/types/generic";
import {BASE_DEFINITION_FORM_STEPS} from "../constants";
import {ExceptionListEntityResponse} from "../api/types/exceptionList";

export const ancillarySelectAtom = atom<AncillarySelectFE[]>({
    key: "ancillarySelectAtom",
    default: []
});

export const ancillaryListAtom = atom<SelectElementModelFE[]>({
    key: "ancillaryListAtom",
    default: []
});

export const ancillaryAtom = atom<AncillaryEntityResponse | null>({
    key: "ancillaryAtom",
    default: null
});

export const exceptionPackAtom = atom<ExceptionListEntityResponse | null>({
    key: "exceptionPackAtom",
    default: null
})

export const initialAncillaryFilters: FormSearchAncillaryModel = {
    ancillaryCode: "",
    commercialCategoryId: null,
    commercialSegmentId: null,
    ancillaryType: "",
    pickupDateFrom: "",
    pickupDateTo: "",
    reservationFrom: "",
    reservationTo: "",
    dealers: [],
    legalEntities: []
};
export const ancillaryFiltersAtom = atom<FormSearchAncillaryModel>({
    key: "ancillaryFiltersAtom",
    default: initialAncillaryFilters
});

export const initialAncillaryCreation: AncillaryCreation = {
    step: BASE_DEFINITION_FORM_STEPS.DEFINITION,
    readOnly: true,
    inUse: false,
    completed: [false, false, false]
};
export const ancillaryCreationAtom = atom({
    key: "ancillaryCreationAtom",
    default: initialAncillaryCreation
});

export const ancillaryServiceItem = atom({
    key: "ancillaryServiceItem",
    default: []
});
